/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export enum GroupType {
  ACTION = 'ACTION',
  ANTENNA = 'ANTENNA',
  ANTENNAINSTANCE = 'ANTENNAINSTANCE',
  ASSET = 'ASSET',
  TAG = 'TAG',
  EVENT = 'EVENT',
  LOCATION = 'LOCATION',
  LOCATIONINSTANCE = 'LOCATIONINSTANCE',
  OBJECT = 'OBJECT',
  OBJECTINSTANCE = 'OBJECTINSTANCE',
  READZONE = 'READZONE',
  READZONEINSTANCE = 'READZONEINSTANCE',
  READER = 'READER',
  READERINSTANCE = 'READERINSTANCE',
  RULE = 'RULE',
  USER = 'USER',
  SERVICE = 'SERVICE',
  SERVICEINSTANCE = 'SERVICEINSTANCE',
  SERVEROBJECT = 'SERVEROBJECT',
  SERVEROBJECTINSTANCE = 'SERVEROBJECTINSTANCE',
  DRIVEROBJECT = 'DRIVEROBJECT',
  DRIVEROBJECTINSTANCE = 'DRIVEROBJECTINSTANCE'
}
